export default __webpack_public_path__ + "static/media/fee-grey.769dd1a0.svg";